export default __webpack_public_path__ + "static/media/cargoLoader.b0e99487.png";